import {
  TIMESLOT_ERROR,
  EDIT_TIMESLOT_SUCCESS,
  GET_TIMESLOT
} from "../constants/timeslotConstants";
import Axios from "axios";
import { API_ROOT } from "../components/utils/api-config";
import { setAlert } from "./alertAction";
let token = "Bearer " + localStorage.getItem("token");
const config = {
  headers: {
    Authorization: token,
  },
};
export const requestTimeslot = id => dispatch => {
  Axios.get(`${API_ROOT}/bookings/${id}/`, config)
    .then(response => dispatch({ type: GET_TIMESLOT, payload: response.data }))
    .catch(error => dispatch({ type: TIMESLOT_ERROR, payload: error }));
};

export const editTimeslot = timeslot => dispatch => {
  dispatch({ type: EDIT_TIMESLOT_SUCCESS, payload: timeslot });
  dispatch(setAlert("Timeslot profile changed", "success"));
};
